import type { CarriersRepDirectoryStats } from "../types";

export const MOCK_STATS: CarriersRepDirectoryStats = {
  carriers: 12,
  activeReps: 51,
  rules: 96,
  needsReview: 7,
};
